import { Injectable, signal } from '@angular/core';

/**
 * WorkspaceSidebarStateService
 *
 * Shared state service for workspace sidebar
 * Coordinates sidebar expansion state between sidebar component and app layout
 * Enables dynamic content margin adjustment when sidebar collapses/expands
 */
@Injectable({
  providedIn: 'root',
})
export class WorkspaceSidebarStateService {
  /** Current sidebar width in pixels */
  readonly sidebarWidth = signal<number>(320);

  /** Whether sidebar is expanded */
  readonly isExpanded = signal<boolean>(true);

  /** Update sidebar width and expansion state */
  setSidebarState(width: number, expanded: boolean): void {
    this.sidebarWidth.set(width);
    this.isExpanded.set(expanded);
  }

  /** Toggle sidebar expansion state */
  toggleSidebar(): void {
    this.isExpanded.update((expanded) => !expanded);
  }
}
